import { render, staticRenderFns } from "./BasketContainer.vue?vue&type=template&id=98595a64&scoped=true"
import script from "./BasketContainer.vue?vue&type=script&lang=js"
export * from "./BasketContainer.vue?vue&type=script&lang=js"
import style0 from "./BasketContainer.vue?vue&type=style&index=0&id=98595a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98595a64",
  null
  
)

export default component.exports